var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"sk-navigation-header"},[_c('div',{staticClass:"sk-navigation-header__main"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.hasValue)?_c('h2',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"sk-navigation-header__extra"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17a114c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/NavigationHeader.vue
// module id = null
// module chunks = 